module.exports = __webpack_public_path__ + "static/img/addWx.ed83096.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage/addWx.jpg
// module id = zROg
// module chunks = 0